export const RISK = {
  A: { color: "#10B981", bg: "bg-emerald-50", text: "text-emerald-700", ring: "ring-emerald-200", solid: "bg-emerald-500" },
  B: { color: "#F59E0B", bg: "bg-amber-50", text: "text-amber-700", ring: "ring-amber-200", solid: "bg-amber-500" },
  C: { color: "#F97316", bg: "bg-orange-50", text: "text-orange-700", ring: "ring-orange-200", solid: "bg-orange-500" },
  D: { color: "#EF4444", bg: "bg-red-50", text: "text-red-700", ring: "ring-red-200", solid: "bg-red-500" },
};

export const STATUS_COLOR = {
  good: { dot: "bg-emerald-500", text: "text-emerald-600", bar: "#10B981" },
  warn: { dot: "bg-amber-500", text: "text-amber-600", bar: "#F59E0B" },
  bad: { dot: "bg-red-500", text: "text-red-600", bar: "#EF4444" },
  na: { dot: "bg-slate-300", text: "text-slate-400", bar: "#CBD5E1" },
};

export function fmtEur(v) {
  if (v === null || v === undefined) return "—";
  return new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0 }).format(v) + " €";
}

export function fmtNum(v, unit = "") {
  if (v === null || v === undefined) return "—";
  return `${new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2 }).format(v)}${unit ? " " + unit : ""}`;
}
